import { render } from "./BaseSpinner.vue?vue&type=template&id=5e22ef30&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=5e22ef30&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e22ef30"

export default script